import React, { useCallback, useEffect } from 'react';
import ConnectWidget from '../components/ConnectWidget';
import { setPublicKey } from '../services/api';

const WidgetPage = () => {
  const params = new URLSearchParams(window.location.search);
  const isEmbed = params.get('embed') === 'true';
  const userId = params.get('customerId') || 'user_demo_001';
  const key = params.get('key') || process.env.REACT_APP_PUBLIC_KEY || '';

  useEffect(() => {
    if (key) setPublicKey(key);
  }, [key]);

  const handleSuccess = useCallback((data) => {
    if (isEmbed && window.parent !== window) {
      window.parent.postMessage(
        { source: 'afrilink-connect', type: 'SUCCESS', data },
        '*'
      );
    }
  }, [isEmbed]);

  const handleClose = useCallback(() => {
    if (isEmbed && window.parent !== window) {
      window.parent.postMessage(
        { source: 'afrilink-connect', type: 'CLOSE' },
        '*'
      );
    }
  }, [isEmbed]);

  if (isEmbed) {
    return (
      <div className="min-h-screen flex items-center justify-center p-2">
        <ConnectWidget userId={userId} onSuccess={handleSuccess} onClose={handleClose} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900">AfriLink</h1>
          <p className="text-gray-600 mt-2">Open Banking Widget for Africa</p>
          {!key && (
            <p className="text-amber-600 text-sm mt-4 bg-amber-50 rounded-lg p-3">
              No public key set. Add <code className="bg-amber-100 px-1 rounded">?key=pk_test_...</code> to the URL or set <code className="bg-amber-100 px-1 rounded">REACT_APP_PUBLIC_KEY</code> in your environment.
            </p>
          )}
        </div>
        <ConnectWidget userId={userId} onSuccess={handleSuccess} />
      </div>
    </div>
  );
};

export default WidgetPage;
